import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Timeline.css'; 

const TimelineItem = ({ title, content, targetHash }) => {
  const navigate = useNavigate();

  const handleCardClick = (e) => {
    e.preventDefault();
    navigate(`/experience${targetHash}`);
  };

  return (
    <div className="timeline-item"> 
      <div className="timeline-content" onClick={handleCardClick}>
        <h3>{title}</h3>
        {content.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
        <div className="plus-moreinfo">+</div>
      </div>
    </div>
  );
};

export default TimelineItem;



